<template lang="pug">
.vip-list-container(ref="vipListContainer")
  .title.color_text_1 有道翻译豪华特权升级+有道词典移动端全部特权
  //- .extend-oper
  //-   .exchange.color_text_3(@click="openExchange" v-if="isLogin") 兑换码
  //-   .buy-recharge.color_text_3(@click="buyRecharge" v-if="isLogin && isSVip")
  //-     .content 购买加量包
  //-     img.icon(src="@/assets/imgs/vip/light/questionmark.png" @mouseenter="mouseenter" @mouseleave="mouseleave")
  //-     .recharge-desc.color_label_2.color_text_2(v-if="isShowDesc") 可享受更多文档翻译字符
  .vip-list(ref="vipList")
    .vip-list-item.color_main_vip_1_border(
      v-for="(item, index) in vipList"
      :key="index"
      :ref="`vipItem_${index}`"
      :class="item.planId === currentPackage.planId ? ['active'] : ''"
      @click="choiceItem(item, index)"
    )
      //- .vip-type(
      //-   :class="item.planId === currentPackage.planId ? 'color_text_vip_0' : 'color_text_1'"
      //- ) {{item.period}}
      .vip-type(
        :class="item.planId === currentPackage.planId ? 'color_text_vip_2' : 'color_text_1'"
      ) {{ item.trial ? item.pcPromoteInfo : item.period}}
      .vip-price(
        :class="item.planId === currentPackage.planId ? 'color_vip_price' : 'color_text_1'"
      )
        .unit(v-if="!item.trial") ￥
        .price {{item.trial ? item.periodDesc : item.price}}
      .vip-basicprice.color_text_3(
        v-if="item.basicPrice"
      )
        .unit ￥
        .price {{item.basicPrice}}
      .vip-desc(
        :class="item.planId === currentPackage.planId ? 'color_bg_vip_1_text' : 'color_text_2'"
      ) {{item.shortDesc}}
      .vip-tag(v-if="(item.firstTag && item.firstTag !== '') || item.tag !== ''") {{item.firstTag || item.tag}}
  .walfare(v-if="walfareDetails.discountList && walfareDetails.discountList.length > 0")
    .walfare-header
      .walfare-title {{walfareDetails.discountTitle}}
      .walfare-desc.color_text_3(v-if="walfareDetails.discountInfo") {{walfareDetails.discountInfo}}
      .walfare-policy.color_text_2(@click="openWalfarePolicy" v-if="walfareDetails.policyInfo && walfareDetails.policyUrl") {{walfareDetails.policyInfo}}
    .walfare-list(ref="walfareList")
      .walfare-list-item.color_label_vip_tint_1_opacity(v-for="(item, index) in walfareDetails.discountList" :key="index" @click="choiceWalfareItem(item, index)")
        img.walfare-item-icon(:src="item.type === 0 ? require('@/assets/imgs/vip/light/walfare_icon0.png') : item.type === 1 ? require('@/assets/imgs/vip/light/walfare_icon1.png') : require('@/assets/imgs/vip/light/walfare_icon2.png')")
        .walfare-item-title.color_text_vip_2 {{item.name}}
        .walfare-item-price.color_vip_price(v-if="item.basicPrice !== undefined")
          .unit ￥
          .price {{item.price}}
        .walfare-item-basicPrice.color_text_3
          .price {{item.basicPrice}}
        .walfare-item-timeLeft.color_text_vip_2(v-if="remainTime > 0 && item.type === 1")
          .digital.color_label_stress_bg {{countDownTime.hour}}
          span 时
          .digital.color_label_stress_bg {{countDownTime.minute}}
          span 分
          .digital.color_label_stress_bg {{countDownTime.second}}
          span 秒
          span.last 后结束
  //- exchangePopUp(ref="exchangePopUp" @exchange="exchange")
  //- morePackage(v-if='showMore' @closeMorePackage='closeMorePackage')
</template>
<script>
import vip from '@/service/vip';
import exchangePopUp from '@/components/exchangePopUp.vue';
import morePackage from '@/components/morePackage.vue';
// import util from '@/util/localstorage.js';
import utilIndex from '@/util/index.js';

export default {
  name: 'vipPackageList',
  props: ['isSVip', 'isLogin'],
  components: {
    exchangePopUp,
    morePackage,
  },
  data() {
    return {
      vipList: [],
      currentPackage: {},
      isShowDesc: false,
      source: '',
      showMore: false,
      walfareDetails: {
        discountInfo: '',
        discountTitle: '',
        policyInfo: '',
        policyUrl: '',
        discountList: [],
      },
      timer: '',
      countDownTime: {
        hour: '',
        minute: '',
        second: '',
      },
      remainTime: 0,
    };
  },
  mounted() {
    this.getVipList();
  },
  watch: {
    currentPackage: {
      handler(val) {
        this.$emit('currentChoose', val);
        this.getCurrentWalfare(val.planId);
      },
      deep: true,
    },
    // 高价实验
    // '$route.query': {
    //   handler(val) {
    //     if (val.keyfrom === 'vip_benefit') {
    //       util.setInfo('spec_vip_benefit', true, 86400000 * 3); // 3天过期时间
    //     }
    //   },
    //   immediate: true,
    // },
    // '$store.state.user.account': {
    //   handler() {
    //     this.getVipList();
    //   },
    //   deep: true,
    // },
  },
  methods: {
    countDown() {
      this.remainTime -= 1000;
      if (this.remainTime <= 1000) {
        clearInterval(this.timer);
        this.isOverdue = true;
        this.countDownTime = this.$options.data().countDownTime;
      } else {
        this.countDownTime = utilIndex.dateFormatHMS(new Date(this.remainTime));
      }
    },
    timing() {
      const that = this;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        that.countDown();
      }, 1000);
    },
    getCurrentWalfare(planId) {
      vip.getSingleSvipWelfare({ planId }).then((res) => {
        if (res.code === 0) {
          this.walfareDetails = res.data;
          if (res.data.discountList !== undefined && res.data.discountList.length > 0) {
            this.$emit('currentIsHaveWalfare', true);
            const { timeLeft } = res.data.discountList.find((item) => item.type === 1) || 0;
            this.remainTime = timeLeft && timeLeft <= 86400000 * 3 ? timeLeft : 0;
          } else {
            this.$emit('currentIsHaveWalfare', false);
          }
          if (this.remainTime > 0) {
            this.timing();
          }
        }
      });
    },
    openWalfarePolicy() {
      window.open(this.walfareDetails.policyUrl);
    },
    choiceWalfareItem(item, i) {
      // 点击最右边的套餐（约束从第3个起）向右滑动
      if (i >= 2) {
        this.$refs.walfareList.scrollTo({
          left: 186 + (i - 2) * 227,
          behavior: 'smooth',
        });
      // 点击最左边的套餐（约束从第2个起）向左滑动
      } else if (i <= 2) {
        this.$refs.walfareList.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      }
    },
    closeMorePackage() {
      this.showMore = false;
    },
    mouseenter() {
      this.isShowDesc = true;
    },
    mouseleave() {
      this.isShowDesc = false;
    },
    // 跳转购买加量包窗口
    buyRecharge() {
      this.showMore = true;
    },
    getVipList() {
      const param = {
        imei: '1',
        // 高价实验
        // keyfrom: util.getInfo('spec_vip_benefit') ? 'vip_benefit' : 'webdict',
        keyfrom: 'webdict',
        apiversion: '1.0',
        appVersion: '1',
        client: 'deskdict',
        product: 'web',
        vendor: '',
        yduuid: '1',
      };
      vip.getVipList(param).then((res) => {
        this.vipList = res;
        const current = res[0];
        this.currentPackage = current;
      });
    },
    // choiceItem(item) {
    //   this.currentPackage = item;
    // },
    openExchange() {
      this.$refs.exchangePopUp.showPopUp();
    },
    exchange(val) {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        platform: 'webdict',
        code: val,
      };
      vip.exchangeVipCode(param).then((res) => {
        if (res.success) {
          this.$toast('兑换成功');
          // 更新vip当前页面
          window.location.reload(true);
        } else if (res.errorCode === 2308) {
          this.$toast('兑换请求频繁');
        } else if (res.errorCode === 2309) {
          this.$toast('会员码兑换失败（已经是VIP会员）');
        } else if (res.errorCode === 2310) {
          this.$toast('会员码兑换失败（会员码已过期）');
        } else if (res.errorCode === 2311) {
          this.$toast('会员码兑换失败（会员码已被使用）');
        } else if (res.errorCode === 2312) {
          this.$toast('会员码兑换失败（会员码不存在）');
        } else {
          this.$toast('会员码兑换失败');
        }
      });
    },
    choiceItem(item, i) {
      const itemPosition = this.$refs[`vipItem_${i}`][0].offsetLeft - this.$refs.vipListContainer.clientWidth / 2 + 79;
      // 非边界元素居于中轴线上
      this.$refs.vipList.scrollTo({
        left: itemPosition,
        behavior: 'smooth',
      });
      this.currentPackage = item;
    },
  },
};
</script>
<style lang="stylus" scoped>
.vip-list-container
  position relative
  margin-top 32px
  .extend-oper
    position: absolute
    top 29px
    right 0
  .exchange
    width 60px
    height 28px
    display: inline-block
    margin-right 8px
    border-radius 6px
    border: 0.5px solid #C8C9CC
    font-size 12px
    text-align center
    line-height 28px
    cursor pointer
    vertical-align: top
  .buy-recharge
    width 95px
    height 28px
    display: inline-block
    border-radius 6px
    border: 0.5px solid #C8C9CC
    font-size 12px
    text-align center
    line-height 28px
    cursor pointer
    vertical-align: top
    .content
      display: inline-block
      vertical-align: top
    .icon
      width 12px
      height 12px
      vertical-align: middle
      margin-bottom 1px
      margin-left 3.5px
    .recharge-desc
      border 1px solid #DCDCDC
      box-shadow 0px 1.2px 3.6px rgba(0, 0, 0, 0.1), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)
      border-radius 4px
      font-size 12px
      text-align center
      width 146px
      height 28px
      line-height 28px
      z-index 100
      position: absolute
      top 34px
      left 40px
  .title
    font-size 12px
    line-height 14px
  .vip-list
    display: flex
    justify-content: space-between
    overflow-x scroll
    padding-top 26px
    margin-right -28px
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow: -moz-scrollbars-none; /* Firefox */
    .vip-list-item
      width 169px
      height 127px
      border-radius 8px
      text-align center
      box-sizing: border-box
      flex-shrink 0
      position relative
      cursor pointer
      .vip-type
        font-size 14px
        line-height 17px
        margin-top 19px
        font-weight 400
      .vip-price
        font-family 'Gilroy-SemiBold'
        .unit
          font-size 14px
          font-weight 700
          display inline-block
        .price
          font-size 24px
          font-weight 600
          line-height 41px
          display inline-block
          height 36px
      .vip-basicprice
        font-family 'Gilroy'
        position relative
        top -3px
        .unit
          font-size 12px
          font-weight 500
          display: inline-block
          text-decoration-line: line-through;
        .price
          font-size 12px
          font-weight 500
          display: inline-block
          line-height 12px
          text-decoration-line: line-through;
      .vip-desc
        width 100%
        height 27px
        font-size 12px
        margin-top 2px
        text-align: center
        line-height: 27px
        background: rgba(230,231,232, 0.7)
        border-radius 0 0 7px 7px
        position: absolute
        bottom: 0
      .vip-tag
        height 12px
        color #FFFFFF
        line-height 12px
        font-size 12px
        position: absolute
        top -11px
        left -1px
        background: linear-gradient(97.76deg, #FF635E -1.73%, #FF825E 100.77%);
        box-shadow: 0px 1px 8px 0px #CD27271A;
        padding 4px 6px
        border-radius 8px 3px 8px 3px
    .active
      background: linear-gradient(197.1deg, #FFE7BF -14.71%, #FFEACC 26.63%, #FFFBE3 83.56%);
      .vip-desc
        background: url('../assets/imgs/vip/light/desc-bg.png') 0 0 / 100% 100% no-repeat
        bottom: -1px
        left: -1px
        width: calc(100% + 2px)
        height 28.5px
  .walfare
    margin-top 17px
    .walfare-header
      display: flex
      align-items center
      line-height 14px
      .walfare-title
        font-size 14px
        line-height 15px
        font-weight 800
        background: linear-gradient(129deg, #FF635E 2.83%, #FF825E 72.71%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      .walfare-desc
        font-size 12px
        margin 0 2px 0 12px
      .walfare-policy
        font-size 12px
        cursor pointer
    .walfare-list
      margin-top 10px
      display: flex
      width 585px
      overflow-x scroll
      .walfare-list-item
        display: flex
        align-items center
        padding 15px 14px 15px 13px
        border-radius: 8px
        height 14px
        width fit-content
        margin-right 12px
        white-space nowrap
        cursor pointer
        .walfare-item-icon
          width 14px
          height 14px
          display: block
        .walfare-item-title
          margin 0 0 0 4px
          font-size 12px
        .walfare-item-price
          margin-left 19px
          font-family 'Gilroy'
          line-height 14px
          .unit
            font-size 13px
            font-weight 600
            display inline-block
            vertical-align: bottom
            position relative
            top 1px
          .price
            font-size 16px
            font-weight 600
            line-height 14px
            display inline-block
            font-family 'Gilroy'
            vertical-align: text-bottom
        .walfare-item-basicPrice
          margin-left: 4px;
          line-height: 12px;
          position: relative;
          top: 2px;
          font-family 'Gilroy'
          .price
            font-family: Gilroy;
            font-size: 12px;
            font-weight: 500;
            line-height: 12px;
            text-decoration: line-through;
        .walfare-item-timeLeft
          margin-left 8px
          line-height 14px
          .digital
            display inline-block
            width 22px
            height 26px
            border-radius 5px
            line-height 26px
            text-align center
            color #FF7C5F
            margin 0 4px
          .last
            margin-left 4px
.vip-list-container
  .vip-list
    // width 622px
    .vip-list-item
      width 21.5%
      margin-left 13px
      &:first-child
        margin-left 0
    &::after
      content "28p"
      display block
      height 0
      clear both
      visibility hidden //占位但不可见
</style>
